import AuthService from './AuthService';
import ApiService from "./ApiService";

class ProductService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._listUrl = '/products';
        this._atributesUrl = '/products/attributes';
        this._distributorsTableUrl = '/products/distributors/table';
        this._singleUrl = '/products/single';
        this._getProductRateUrl = '/products/rate/get';
        this._setProductRateUrl = '/products/rate/set';
        this._getProductFeedbacksUrl = '/products/feedback/list';
        this._createProductFeedbacksUrl = '/products/feedback/create';
        this._getRecommendedProductsUrl = '/products/recommendation';
        this._sortProductsUrl = '/products/sort';
        this._getPopularUrl = '/products/home';
        this._getDiscountUrl = '/products/home/discount';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    getAtributes(filters) {
        return this.postResource(this._atributesUrl, {filters}, this.getLangHeader());
    }

    getList(filters, page, pagination, sortCategories, attribute) {
        const params = {
            filters: filters,
            page: page,
            sortType: sortCategories.sortType,
            order: sortCategories.order,
        };

        if(pagination) params.pagination = pagination;
        if(attribute) params.attributeName = attribute;

        return this.postResource(this._listUrl, params, this.getLangHeader());
    }

    getDistributorsTable(filters) {
        const params = {filters: filters};

        return this.postResource(this._distributorsTableUrl, params, this.getLangHeader());
    }
    getSingle(filters) {
        const params = {
            filters: filters,
        };
        return this.postResource(this._singleUrl, params, this.getLangHeader());
    }
    getProductRate(id) {
        const params = {productId: id};

        return this.postResource(this._getProductRateUrl, params, this.getLangHeader());
    }
    setProductRate(params) {

        return this.postResource(this._setProductRateUrl, params, this.getBaseHeaders());
    }
    getProductFeedback(id) {
        const params = {productId: id};

        return this.postResource(this._getProductFeedbacksUrl, params, this.getLangHeader());
    }
    createProductFeedback(params) {

        return this.postResource(this._createProductFeedbacksUrl, params, this._authService.getAuthHeader());
    }
    getRecommendedProducts(params) {

        return this.postResource(this._getRecommendedProductsUrl, params, this.getLangHeader());
    }
    sortProducts() {

        return this.postResource(this._sortProductsUrl, this.getLangHeader());
    }
    getPopularProducts(params) {
        return this.postResource(this._getPopularUrl, params, this.getLangHeader());
    }
    getDiscountProducts(params) {
        return this.postResource(this._getDiscountUrl, params, this.getLangHeader());
    }
}

const productService = new ProductService(AuthService);

export default productService;
